import { Controller } from "@hotwired/stimulus"
import peity from "./peity-vanilla.js"

export default class extends Controller {


  connect() {
    peity(this.element, "line")
  }

}